// @ts-strict-ignore
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import * as Popover from '@radix-ui/react-popover'
import { utcToZonedTime } from 'date-fns-tz'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  timezone: 'Asia/Singapore' | 'Europe/Amsterdam'
  days: null | string[]
}

const Openinghours: FC<Props> = ({ timezone, days }) => {
  const { t } = useTranslation('rolex')
  const date = new Date()
  const curDayInTimezone = utcToZonedTime(date, timezone).getDay()
  const convertedDay = curDayInTimezone > 0 ? curDayInTimezone - 1 : 6
  const isOpened = days[convertedDay].length > 0

  return (
    <div className="mb-5 w-full">
      <Popover.Root>
        <Popover.Trigger
          asChild
          className="w-full outline-none data-[aria-expanded=true]:[&_svg]:rotate-180"
        >
          <button className="flex w-full items-center">
            <Text variant="fixed16" className={cn('mr-2 font-bold')}>
              {t(`contact.${isOpened ? 'openedToday' : 'closedToday'}`)}
            </Text>
            <Text
              variant="fixed16"
              weight="light"
              className={cn('mr-2 text-current', isOpened && 'text-rolexPrimary')}
            >
              {days[convertedDay]}
            </Text>
            <svg
              height="11"
              width="11"
              viewBox="0 0 11 11"
              className="fill-current transition-transform duration-150"
            >
              <path d="m5.5 9.1-5.5-5.8 1.4-1.4 4 4.2 4-4.2 1.6 1.4z" />
            </svg>
          </button>
        </Popover.Trigger>
        <Popover.Content
          className="relative !z-[10] mt-2 w-full rounded bg-rolexLightBeige p-6 shadow-lg outline-none lg:p-10"
          sideOffset={5}
          side="bottom"
          align="start"
        >
          <div className="flex flex-col gap-3">
            {days.map((day, key) => (
              <div className="grid min-w-[20rem] grid-cols-2 gap-2">
                <Text variant="fixed16" weight="bold">
                  {t(`contact.day_${key}`)}
                </Text>
                <Text variant="fixed16" weight="light" className="text-right">
                  {day.length > 0 ? day : t('contact.closed')}
                </Text>
              </div>
            ))}
          </div>
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}

export default Openinghours
